module.exports = __webpack_public_path__ + "static/img/amd6.d6a8cdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/amd6.png
// module id = OLLI
// module chunks = 1